

/// <reference path="StockNote.ts" />

// Generated class DeliveryNote_ManagedObject

class DeliveryNote_ManagedObject extends StockNote
{
}
